(function($){

    var loaded = false;

    $(document).on("zp-ready", function() {
        zp_init();
    });

    function zp_init()  {
        //zp_unload();
        $(".zp_slider").each(function(index, element) {
            var ele = $(element);
            if(!ele.hasClass("zp-loaded")) {
                ele.addClass("zp-loaded");
                var slider = ele.find(".slider");
                var attr = JSON.parse(slider.attr("data-slider"));
                attr.useCSS = true;
                attr.useTransform = true;
                if(attr.dots) {
                    if(!attr.dotsTop) {
                        ele.append('<div class="slick-dots-container zp_slider_dots"></div>');
                    } else {
                        ele.prepend('<div class="slick-dots-container zp_slider_dots"></div>');
                    }
                    attr.appendDots = ele.find(".zp_slider_dots");
                }
                slider.slick(attr);
                if((attr.slidesToShow == attr.slidesToScroll || attr.slidesToShow) == 1 && attr.dots) {
                    ele.find(".zp_slider_element").each(function (indexsub, elementsub) {
                        var elesub = $(elementsub);
                        var predefined = elesub.attr("data-predefined");
                        $(ele.find(".zp_slider_dots li").get(indexsub)).addClass(predefined);
                    });
                }
                if(attr.equalHeight) {
                    ele.find(".zp_slider_element").matchHeight({property: 'height'});
                }
                if(attr.refreshTimeout != false) {
                    slider.attr("data-refresh-timeout", attr.refreshTimeout);
                    var slicktrack = slider.find(".slick-track");
                    slicktrack.attr("data-height", slider.outerHeight());
                    slider.on("DOMSubtreeModified propertychange", zp_domChange);
                }
            }
        });
        if(!loaded) {
            loaded = true;
            $(document).on("zp-unload", zp_unload);
        }
    }

    function zp_domChange(){
        var slider = $(this);
        var slicktrack = slider.find(".slick-track");
        setTimeout(function(){
            if(slicktrack.outerHeight() != slicktrack.attr("data-height")) {
                var current = slider.slick('slickCurrentSlide');
                slider.get(0).slick.slickGoTo(current);
                slicktrack.attr("data-height", slider.outerHeight());
            }
        }, slider.attr("data-refresh-timeout"));
    }

    function zp_unload() {
        if($(".zp_slider").length > 0) {
            $(".zp_slider .slider").each(function(index, element) {
                var ele = $(element);
                if(ele.hasClass('slick-initialized')) {
                    ele.slick('unslick');
                }
                ele.off("DOMSubtreeModified", zp_domChange);
            });
            // $(document).off("zp-unload", zp_unload);
        }
    }
})(jQuery);
